import { useQuery } from "@tanstack/react-query";
import { API_INTRO } from "../apis";
import { QUERY_KEY } from "../keys";

export const useGetIntro = <T>() => {
    const { data, isLoading } = useQuery({
        queryKey: [QUERY_KEY.GET_INTRO_INFO],
        queryFn: () => API_INTRO.getIntroInfo<T>(),
    });

    return { data, isLoading };
};
